export default "__VITE_ASSET__F45Ngi4V__"